// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: VFfmrmFekX

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicResourceCard.module.css"; // plasmic-import: VFfmrmFekX/css

import AdsClickIcon from "./icons/PlasmicIcon__AdsClick"; // plasmic-import: crQIMbWB1C/icon

createPlasmicElementProxy;

export type PlasmicResourceCard__VariantMembers = {};
export type PlasmicResourceCard__VariantsArgs = {};
type VariantPropType = keyof PlasmicResourceCard__VariantsArgs;
export const PlasmicResourceCard__VariantProps = new Array<VariantPropType>();

export type PlasmicResourceCard__ArgsType = {
  title?: React.ReactNode;
  bodyText?: React.ReactNode;
  tagsText?: React.ReactNode;
  clicksText?: React.ReactNode;
  adImgSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
  logoSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
};
type ArgPropType = keyof PlasmicResourceCard__ArgsType;
export const PlasmicResourceCard__ArgProps = new Array<ArgPropType>(
  "title",
  "bodyText",
  "tagsText",
  "clicksText",
  "adImgSrc",
  "logoSrc"
);

export type PlasmicResourceCard__OverridesType = {
  resourceCard?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  svg?: p.Flex<"svg">;
};

export interface DefaultResourceCardProps {
  title?: React.ReactNode;
  bodyText?: React.ReactNode;
  tagsText?: React.ReactNode;
  clicksText?: React.ReactNode;
  adImgSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
  logoSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
  className?: string;
}

const $$ = {};

function PlasmicResourceCard__RenderFunc(props: {
  variants: PlasmicResourceCard__VariantsArgs;
  args: PlasmicResourceCard__ArgsType;
  overrides: PlasmicResourceCard__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          adImgSrc:
            "https://cdn.logojoy.com/wp-content/uploads/20220329171710/telegram-app-logo.png",
          logoSrc:
            "https://cdn.logojoy.com/wp-content/uploads/20220329171710/telegram-app-logo.png"
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <div
      data-plasmic-name={"resourceCard"}
      data-plasmic-override={overrides.resourceCard}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.resourceCard
      )}
      onClick={async event => {
        const $steps = {};
      }}
    >
      <p.PlasmicImg
        data-plasmic-name={"img"}
        data-plasmic-override={overrides.img}
        alt={""}
        className={classNames(sty.img)}
        displayHeight={
          hasVariant(globalVariants, "screen", "mobileOnly") ? "50px" : "100px"
        }
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={
          hasVariant(globalVariants, "screen", "mobileOnly") ? "80px" : "0"
        }
        displayMinWidth={
          hasVariant(globalVariants, "screen", "mobileOnly") ? "80px" : "0"
        }
        displayWidth={
          hasVariant(globalVariants, "screen", "mobileOnly") ? "auto" : "100px"
        }
        loading={"lazy"}
        src={args.logoSrc}
      />

      <div className={classNames(projectcss.all, sty.freeBox__ltkgq)}>
        <div className={classNames(projectcss.all, sty.freeBox___3N1Gg)}>
          {p.renderPlasmicSlot({
            defaultContents: "Product Title | The best arrow product.",
            value: args.title,
            className: classNames(sty.slotTargetTitle)
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__pU51)}>
          {p.renderPlasmicSlot({
            defaultContents:
              "Do a bunch of arrow stuff with this great arrow product. Trust us!",
            value: args.bodyText,
            className: classNames(sty.slotTargetBodyText)
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__vJgnD)}>
          {p.renderPlasmicSlot({
            defaultContents: "#idea-stage #mvp  #arrow-stuff  #pointy-thing",
            value: args.tagsText,
            className: classNames(sty.slotTargetTagsText)
          })}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___6SvdS)}>
        <AdsClickIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg)}
          role={"img"}
        />

        <div className={classNames(projectcss.all, sty.freeBox__u5UGp)}>
          {p.renderPlasmicSlot({
            defaultContents: "420",
            value: args.clicksText,
            className: classNames(sty.slotTargetClicksText)
          })}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  resourceCard: ["resourceCard", "img", "svg"],
  img: ["img"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  resourceCard: "div";
  img: typeof p.PlasmicImg;
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicResourceCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicResourceCard__VariantsArgs;
    args?: PlasmicResourceCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicResourceCard__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicResourceCard__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicResourceCard__ArgProps,
          internalVariantPropNames: PlasmicResourceCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicResourceCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "resourceCard") {
    func.displayName = "PlasmicResourceCard";
  } else {
    func.displayName = `PlasmicResourceCard.${nodeName}`;
  }
  return func;
}

export const PlasmicResourceCard = Object.assign(
  // Top-level PlasmicResourceCard renders the root element
  makeNodeComponent("resourceCard"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicResourceCard
    internalVariantProps: PlasmicResourceCard__VariantProps,
    internalArgProps: PlasmicResourceCard__ArgProps
  }
);

export default PlasmicResourceCard;
/* prettier-ignore-end */
